import * as React from 'react'
import '../components/sections/Alumni/styles.css'
// components
import Footer from '../components/layouts/Footer'
import QRCode from '../components/sections/Alumni/components/QRCode'
import PodAlumniSection from '../components/sections/Alumni/components/PodAlumniSection'
import RecruitingHeader from '../components/sections/Alumni/components/RecruitingHeader'
import SeeingIsBelievingSection from '../components/sections/Alumni/components/SeeingIsBelievingSection'
import OneWeekImplementationSection from '../components/sections/Alumni/components/OneWeekImplementationSection'
// hooks
import { THEME_KEY, Themes } from '../hooks/useTheme'

const Alumni = () => {
  React.useLayoutEffect(() => {
    localStorage.setItem(THEME_KEY, Themes.LIGHT)
  }, [])

  return (
    <div className='snap-wrap'>
      <RecruitingHeader />
      <section className='alumni-wrapper'>
        <PodAlumniSection />
      </section>
      <section className='alumni-wrapper'>
        <SeeingIsBelievingSection />
      </section>
      <section className='alumni-wrapper'>
        <OneWeekImplementationSection />
      </section>
      <section className='footer-snap-align recruiting-bottom-block'>
        <QRCode />
        <Footer theme='light' />
      </section>
    </div>
  )
}
export default Alumni
